import * as React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import SVG from 'react-inlinesvg';
import close from '../../assets/icons/close.svg';
import { Button } from '../Button/Button';
import styles from './ConfirmationDialog.module.scss';
import { makeStyles } from '@material-ui/core/styles';

export interface ConfirmationOptions {
  catchOnCancel?: boolean;
  variant: 'danger' | 'info' | 'noButtons';
  title: string;
  description?: string;
  confirmationText?: string;
  cancelText?: string;
}

interface ConfirmationDialogProps extends ConfirmationOptions {
  open: boolean;
  onSubmit: () => void;
  onClose: () => void;
  children?: any;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  children,
  open,
  title,
  variant,
  description,
  onSubmit,
  onClose,
  confirmationText,
  cancelText,
}) => {
  const useStyles = makeStyles({
    root: {
      //eslint-disable-next-line
      ['@media (max-width:980px)']: {
        paddingTop: '60px',
      },
    },
  });
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      classes={{
        root: classes.root,
      }}
    >
      <div className={styles.dialog}>
        {variant === 'noButtons' && <SVG src={close} onClick={onClose} />}

        <div className={styles.dialogTitle}>
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        </div>
        <DialogContent>
          <DialogContentText>{description && description}</DialogContentText>
          {children && children}
        </DialogContent>
        {variant !== 'noButtons' && (
          <DialogActions>
            <div className={styles.dialogActions}>
              {variant === 'danger' && (
                <>
                  <Button action={onClose} theme={'secondary'} autoFocus>
                    {cancelText}
                  </Button>
                  <Button action={onSubmit} theme={'primary'}>
                    {confirmationText}
                  </Button>
                </>
              )}

              {variant === 'info' && (
                <Button theme={'primary'} action={onSubmit}>
                  OK
                </Button>
              )}
            </div>
          </DialogActions>
        )}
      </div>
    </Dialog>
  );
};
